import {getMorphoService, serviceNames} from '@/rte/editor';
import {Path} from './typings';

const getEditor = () => {
    const editorStateService = getMorphoService(serviceNames.IEditorStateService);
    if (!editorStateService) {
        return null;
    }
    const editor = editorStateService.editor;
    if (!editor) {
        return null;
    }
    return editor;
};


/**
 * 在 children 中，根据结点的 type 查找对应的结点
 */
const findNodesByType = (type: string, children: any[]): any[] => {
    const result: any[] = [];

    children.forEach((node) => {
        if (node && node.type === type) {
            result.push(node);
        }
        if (node && node.children) {
            result.push(...findNodesByType(type, node.children));
        }
    });

    return result;
};


/**
 * 在 children 中，根据结点的 id 查找对应的结点
 */
const findNodeById = (id: string, children: any[], parentPath: Path, idName?: string): null | [any, Path] => {
    idName = idName || 'blockId';
    for (let i = 0; i < children.length; i++) {
        const node = children[i];
        if (node && node[idName] === id) {
            return [node, parentPath.concat(i)];
        }
        else if (node && node.children) {
            const res = findNodeById(id, node.children, parentPath.concat(i), idName);
            if (res) {
                return res;
            }
        }
    }
    return null;
};

export {getEditor, findNodesByType, findNodeById};
